export const AUTH_ENDPOINTS = {
  // Gera token de autorização da aplicação.
  auth: '/Auth',
  // Gera hora em UTC com acréscimo de um minuto.
  getTime: '/Auth/GetTime',
  // Realiza autenticação do usuário e gera token de acesso
  login: '/Auth/Mobile/Login',
  // Renova o token JWT do usuário
  refreshJwt: '/Auth/RefreshJwt',
} as const

export const AUTHORIZATION_TOKEN_ENDPOINTS = {
  // Gera token não autenticado para reset de senha
  generateToken:
    '/AuthorizationToken/GenerateUnauthenticatedAuthorizationToken',
  // Valida token não autenticado para reset de senha
  validateToken:
    '/AuthorizationToken/ValidateUnauthenticatedAuthorizationToken',
} as const

export const USER_ENDPOINTS = {
  // Retorna as informações do usuário
  getUser: '/User',
  // Cria uma nova senha temporária para o usuário
  resetPassword: '/User/Mobile/ResetPassword',
  // Atualiza a senha do usuário
  changePassword: '/User/Mobile/ChangePassword',
} as const

export const JOURNEY_ENDPOINTS = {
  // Verifica se existe journey ativa para o usuário
  getJourney: '/Journey/GetJourney',
  // Cria uma nova journey para o usuário
  createJourney: '/Journey',
  // Conclui a jornada atual
  concludeJourney: '/Journey/ConcludeJourney',
} as const

export const COLLECTION_ORDER_ENDPOINTS = {
  // Cria uma nova ordem de cobrança (CreateCollectionOrder)
  create: '/CollectionOrder/GenerateCollectionOrder',
  // Retorna o status de uma ordem de cobrança (GetCollectionOrderStatus)
  getStatus: '/CollectionOrder/GetCollectionOrderStatus',
} as const
